import { render, staticRenderFns } from "./WebhookRow.vue?vue&type=template&id=b043fa42&scoped=true&"
import script from "./WebhookRow.vue?vue&type=script&lang=js&"
export * from "./WebhookRow.vue?vue&type=script&lang=js&"
import style0 from "./WebhookRow.vue?vue&type=style&index=0&id=b043fa42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b043fa42",
  null
  
)

export default component.exports